/**
 * Emit hosts for the `tab` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';

export function trackTabSharingDoNoShowMessageAgain() {
  track({
    event_name: TrackingEventName.TabSharingDoNoShowMessageAgain,
  });
}

export function trackTabSharingNotAvailableModalShown() {
  track({
    event_name: TrackingEventName.TabSharingNotAvailableModalShown,
  });
}
